import env from './env';

// Experimental support for all browsers
export default () => env.isChromium || env.isFirefox || env.isSafari;
